import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GetEmailAddressRecoveryPIIFieldsService } from '@modules/api/get-email-address-recovery-pii-fields.service.generated';
import { PIIAnswer } from '@modules/api/pii-answer.generated';
import { RecoverEmailAddressService } from '@modules/api/recover-email-address.service.generated';
import { BuildPIIQuestionsFormArrayService } from '@modules/login-shared/services/build-pii-questions-form-array.service';
import { PIIQuestionFormGroup } from '@modules/login-shared/types/pii-question-form-group.type';

@Component({
    selector: 'app-login-recover-email-address',
    templateUrl: './login-recover-email-address.component.html',
    styleUrls: ['./login-recover-email-address.component.scss']
})
export class LoginRecoverEmailAddressComponent implements OnInit {
    public form?: LoginRecoverEmailAddressFormGroup;
    public readonly emailAddressControl = new FormControl('');
    public answersAreInvalid: boolean = false;
    public accountNotSetUp: boolean = false;
    public currentStepIndex: number = 0;

    constructor(
        private readonly _formBuilder: FormBuilder,
        private readonly _recoverEmailAddressService: RecoverEmailAddressService,
        private readonly _getEmailAddressRecoveryPIIFieldsService: GetEmailAddressRecoveryPIIFieldsService,
        private readonly _buildPIIQuestionsFormArrayService: BuildPIIQuestionsFormArrayService,
    ) { }

    public ngOnInit(): void {
        this._getEmailAddressRecoveryPIIFieldsService.getEmailAddressRecoveryPIIFields().subscribe(result => {
            this.form = this._formBuilder.group({
                piiQuestions: this._buildPIIQuestionsFormArrayService.buildPIIQuestionsFormArray(result.fields || []),
                captcha: ['', Validators.required]
            });
        });
    }

    public onSubmit(): void {
        if (!this.form!.valid) {
            return;
        }

        //Reset errors
        this.answersAreInvalid = false;
        this.accountNotSetUp = false;

        this._recoverEmailAddressService.recoverEmailAddress({
            answers: this.getAnswersFromForm(),
            captchaCode: this.form!.controls.captcha.value!,
        }).subscribe(result => {
            this.answersAreInvalid = result.answersAreInvalid;

            if (result.answersAreInvalid) {
                this.form!.controls.captcha.reset();
                return;
            }

            //If there are no errors but no email address was returned, then the user's account
            //must not be set up yet.
            this.accountNotSetUp = !result.emailAddress;
            if (this.accountNotSetUp) {
                return;
            }

            this.emailAddressControl.setValue(result.emailAddress!);
            this.nextStep();
        });
    }

    private nextStep(): void {
        this.currentStepIndex++;
    }

    private getAnswersFromForm(): PIIAnswer[] {
        return this.form!.controls.piiQuestions.controls
            .map<PIIAnswer>(questionFormGroup => ({
                casePersonalInfoFieldId: questionFormGroup.controls.piiField.value.casePersonalInfoFieldId,
                answer: questionFormGroup.controls.answer.value,
            }));
    }
}

type LoginRecoverEmailAddressFormGroup = FormGroup<{
    piiQuestions: FormArray<PIIQuestionFormGroup>,
    captcha: FormControl<string | null>,
}>;